import React from "react";
import {Icon} from "peggirkit";
import {ExclamationCircleIcon, ExclamationTriangleIcon} from "@heroicons/react/16/solid";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";

const BusyIndication = () => {
    const {dashboardLocation} = useRestaurant();
    const isClosed = dashboardLocation.statusDelivery === "CLOSED" || dashboardLocation.statusTakeaway === "CLOSED"
    const isBusy = dashboardLocation.statusDelivery === "BUSY" || dashboardLocation.statusTakeaway === "BUSY"

    if (isClosed) {
        return (
            <Icon
                className={"size-[14px] animate-pulse fill-red-500"}
                icon={ExclamationCircleIcon}
            />
        );
    }

    if (isBusy) {
        return (
            <Icon
                className={"size-[14px] fill-yellow-600 dark:fill-yellow-300"}
                icon={ExclamationTriangleIcon}
            />
        );
    }

    return <></>;
};

export default BusyIndication;